export const GET_SEARCH_RESULTS = 'GET_SEARCH_RESULTS';

export function getSearchResults(params) {
  return {
    type: GET_SEARCH_RESULTS,
    request: {
      op: 'get',
      path: `/@search`,
      params: params,
    },
  };
}
